var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.24.887H1.76C.788.887 0 1.672 0 2.64v17.137c0 .968.788 1.753 1.76 1.753h29.48c.972 0 1.76-.785 1.76-1.753V2.64c0-.968-.788-1.753-1.76-1.753z",
    fill: "#0E4C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.159 16.085a3.31 3.31 0 01-3.316 3.303H5.84V6.332A3.31 3.31 0 019.157 3.03H27.16v13.056z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.29 11.495c.514.011 1.031-.023 1.543.018.519.096.644.878.183 1.134-.314.169-.688.063-1.028.093h-.698v-1.245zm1.84-1.409c.115.402-.274.762-.662.707H21.29c.008-.379-.016-.79.012-1.149.472.014.948-.027 1.417.022a.56.56 0 01.412.42zm2.835-5.956c.022.767.003 1.574.01 2.357-.002 3.182.003 6.364-.003 9.545-.02 1.193-1.081 2.229-2.27 2.253-1.19.004-2.38 0-3.57.002v-4.81c1.296-.007 2.594.013 3.89-.01.601-.038 1.26-.434 1.288-1.093.07-.662-.556-1.12-1.15-1.192-.23-.006-.223-.066 0-.093.567-.122 1.012-.707.845-1.293-.142-.616-.826-.854-1.395-.853-1.159-.008-2.319-.001-3.478-.003.007-.898-.016-1.797.012-2.695.092-1.17 1.18-2.136 2.352-2.115h3.47z",
    fill: "url(#paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.029 6.367c.03-1.19 1.095-2.218 2.282-2.236 1.186-.003 2.371 0 3.557-.001-.003 3.983.006 7.967-.005 11.95-.046 1.176-1.1 2.184-2.274 2.205-1.188.004-2.376 0-3.564.002v-4.973c1.154.272 2.364.387 3.541.207.704-.113 1.474-.457 1.712-1.184.175-.622.076-1.277.103-1.915V8.94h-2.037c-.01.98.018 1.962-.015 2.942-.055.602-.653.984-1.223.964-.707.007-2.108-.51-2.108-.51-.003-1.838.02-4.138.03-5.97z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.628 9.538c-.107.023-.022-.364-.05-.51.008-.928-.015-1.855.013-2.782.092-1.176 1.188-2.144 2.365-2.116h3.465c-.003 3.983.007 7.967-.005 11.95-.045 1.176-1.1 2.184-2.274 2.205-1.187.004-2.375 0-3.563.002v-5.448c.811.663 1.914.766 2.924.768.762 0 1.52-.117 2.26-.292v-.998c-.834.414-1.814.677-2.739.439a1.486 1.486 0 01-1.102-1.444c-.075-.69.33-1.417 1.01-1.622.845-.263 1.766-.062 2.557.28.17.089.342.199.274-.084v-.784c-1.324-.314-2.733-.43-4.063-.088-.384.108-.76.272-1.072.524z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 20.132,
    y1: 11.208,
    x2: 25.975,
    y2: 11.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 7.025,
    y1: 11.208,
    x2: 12.868,
    y2: 11.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 13.579,
    y1: 11.208,
    x2: 19.421,
    y2: 11.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E2B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.0eaa45e4297e2d37da12e890c8d6b46b.svg";
export { ForwardRef as ReactComponent };